import { render } from "./TopChannels.vue?vue&type=template&id=560fba40"
import script from "./TopChannels.vue?vue&type=script&lang=js"
export * from "./TopChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__